export const userConstants = {
  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",

  UPDATETOKEN_REQUEST: "USERS_UPDATETOKEN_REQUEST",
  UPDATETOKEN_SUCCESS: "USERS_UPDATETOKEN_SUCCESS",
  UPDATETOKEN_FAILURE: "USERS_UPDATETOKEN_FAILURE",

  CHECKMAGICLINK_REQUEST: "USERS_CHECKMAGICLINK_REQUEST",
  CHECKMAGICLINK_SUCCESS: "USERS_CHECKMAGICLINK_SUCCESS",
  CHECKMAGICLINK_FAILURE: "USERS_CHECKMAGICLINK_FAILURE",

  SWITCHSITE_REQUEST: "USERS_SWITCHSITE_REQUEST",
  SWITCHSITE_SUCCESS: "USERS_SWITCHSITE_SUCCESS",
  SWITCHSITE_FAILURE: "USERS_SWITCHSITE_FAILURE",

  LOGOUT: "USERS_LOGOUT",

  GETALL_REQUEST: "USERS_GETALL_REQUEST",
  GETALL_SUCCESS: "USERS_GETALL_SUCCESS",
  GETALL_FAILURE: "USERS_GETALL_FAILURE",

  GETPAGINATED_REQUEST: "USERS_GETPAGINATED_REQUEST",
  GETPAGINATED_SUCCESS: "USERS_GETPAGINATED_SUCCESS",
  GETPAGINATED_FAILURE: "USERS_GETPAGINATED_FAILURE",

  CLEARLIST_REQUEST: "USERS_CLEARLIST_REQUEST",
  CLEARLIST_SUCCESS: "USERS_CLEARLIST_SUCCESS",
  CLEARLIST_FAILURE: "USERS_CLEARLIST_FAILURE",

  GETDETAILS_REQUEST: "USERS_GETDETAILS_REQUEST",
  GETDETAILS_SUCCESS: "USERS_GETDETAILS_SUCCESS",
  GETDETAILS_FAILURE: "USERS_GETDETAILS_FAILURE",

  RESETDETAILS: "USERS_RESETDETAILS",

  RESETME: "USERS_RESETME",

  MYPROFILE_REQUEST: "USERS_MYPROFILE_REQUEST",
  MYPROFILE_SUCCESS: "USERS_MYPROFILE_SUCCESS",
  MYPROFILE_FAILURE: "USERS_MYPROFILE_FAILURE",

  PRELOGIN_REQUEST: "USERS_PRELOGIN_REQUEST",
  PRELOGIN_SUCCESS: "USERS_PRELOGIN_SUCCESS",
  PRELOGIN_FAILURE: "USERS_PRELOGIN_FAILURE",

  UPDATE_REQUEST: "USERS_UPDATE_REQUEST",
  UPDATE_SUCCESS: "USERS_UPDATE_SUCCESS",
  UPDATE_FAILURE: "USERS_UPDATE_FAILURE",

  DELETE_REQUEST: "USERS_DELETE_REQUEST",
  DELETE_SUCCESS: "USERS_DELETE_SUCCESS",
  DELETE_FAILURE: "USERS_DELETE_FAILURE",

  ADD_REQUEST: "USERS_ADD_REQUEST",
  ADD_SUCCESS: "USERS_ADD_SUCCESS",
  ADD_FAILURE: "USERS_ADD_FAILURE",

  GETBYID_REQUEST: "USERS_GETBYID_REQUEST",
  GETBYID_SUCCESS: "USERS_GETBYID_SUCCESS",
  GETBYID_FAILURE: "USERS_GETBYID_FAILURE",

  GETNUSERS_REQUEST: "USERS_GETNUSERS_REQUEST",
  GETNUSERS_SUCCESS: "USERS_GETNUSERS_SUCCESS",
  GETNUSERS_FAILURE: "USERS_GETNUSERS_FAILURE",

  ADDABLEUSERSBYSTRING_REQUEST: "USERS_ADDABLEUSERSBYSTRING_REQUEST",
  ADDABLEUSERSBYSTRING_SUCCESS: "USERS_ADDABLEUSERSBYSTRING_SUCCESS",
  ADDABLEUSERSBYSTRING_FAILURE: "USERS_ADDABLEUSERSBYSTRING_FAILURE",

  FAVOURITEBOARD_REQUEST: "USERS_FAVOURITEBOARD_REQUEST",
  FAVOURITEBOARD_SUCCESS: "USERS_FAVOURITEBOARD_SUCCESS",
  FAVOURITEBOARD_FAILURE: "USERS_FAVOURITEBOARD_FAILURE",

  CHANGEPASSWORD_REQUEST: "USERS_CHANGEPASSWORD_REQUEST",
  CHANGEPASSWORD_SUCCESS: "USERS_CHANGEPASSWORD_SUCCESS",
  CHANGEPASSWORD_FAILURE: "USERS_CHANGEPASSWORD_FAILURE",

  RESETPASSWORD_REQUEST: "USERS_RESETPASSWORD_REQUEST",
  RESETPASSWORD_SUCCESS: "USERS_RESETPASSWORD_SUCCESS",
  RESETPASSWORD_FAILURE: "USERS_RESETPASSWORD_FAILURE",

  GETBYEMAIL_REQUEST: "USERS_GETBYEMAIL_REQUEST",
  GETBYEMAIL_SUCCESS: "USERS_GETBYEMAIL_SUCCESS",
  GETBYEMAIL_FAILURE: "USERS_GETBYEMAIL_FAILURE",

  CLEARADDABLEUSERS: "USERS_CLEARADDABLEUSERS",
  ADDCHOSENONE: "USERS_ADDCHOSENONES",
  REMOVECHOSENONE: "USERS_REMOVECHOSENONES",
  CONFIRMCHOSEN: "USERS_CONFIRMCHOSEN",
  RESTOREADDABLEUSERSLOADED: "USERS_RESTOREADDABLEUSERSLOADED",
  ADDABLEUSERSMORETOLOAD: "USERS_ADDABLEUSERSMORETOLOAD",

  AVATAR_REQUEST: "USERS_AVATAR_REQUEST",
  AVATAR_SUCCESS: "USERS_AVATAR_SUCCESS",
  AVATAR_FAILURE: "USERS_AVATAR_FAILURE",

  REGISTER_REQUEST: "USERS_REGISTER_REQUEST",
  REGISTER_SUCCESS: "USERS_REGISTER_SUCCESS",
  REGISTER_FAILURE: "USERS_REGISTER_FAILURE",

  ACTIVATE_REQUEST: "USERS_ACTIVATE_REQUEST",
  ACTIVATE_SUCCESS: "USERS_ACTIVATE_SUCCESS",
  ACTIVATE_FAILURE: "USERS_ACTIVATE_FAILURE",

  GETCARDS_REQUEST: "USERS_GETCARDS_REQUEST",
  GETCARDS_SUCCESS: "USERS_GETCARDS_SUCCESS",
  GETCARDS_FAILURE: "USERS_GETCARDS_FAILURE",

  ADDCARD_REQUEST: "USERS_ADDCARD_REQUEST",
  ADDCARD_SUCCESS: "USERS_ADDCARD_SUCCESS",
  ADDCARD_FAILURE: "USERS_ADDCARD_FAILURE",

  SETUPINTENT_REQUEST: "USERS_SETUPINTENT_REQUEST",
  SETUPINTENT_SUCCESS: "USERS_SETUPINTENT_SUCCESS",
  SETUPINTENT_FAILURE: "USERS_SETUPINTENT_FAILURE",

  DELETECARD_REQUEST: "USERS_DELETECARD_REQUEST",
  DELETECARD_SUCCESS: "USERS_DELETECARD_SUCCESS",
  DELETECARD_FAILURE: "USERS_DELETECARD_FAILURE",

  SETDEFAULTCARD_REQUEST: "USERS_SETDEFAULTCARD_REQUEST",
  SETDEFAULTCARD_SUCCESS: "USERS_SETDEFAULTCARD_SUCCESS",
  SETDEFAULTCARD_FAILURE: "USERS_SETDEFAULTCARD_FAILURE",

  GETSUBSCRIPTIONS_REQUEST: "USERS_GETSUBSCRIPTIONS_REQUEST",
  GETSUBSCRIPTIONS_SUCCESS: "USERS_GETSUBSCRIPTIONS_SUCCESS",
  GETSUBSCRIPTIONS_FAILURE: "USERS_GETSUBSCRIPTIONS_FAILURE",

  SETUSERSUBSCRIPTION_REQUEST: "USERS_SETSUBSCRIPTION_REQUEST",
  SETUSERSUBSCRIPTION_SUCCESS: "USERS_SETSUBSCRIPTION_SUCCESS",
  SETUSERSUBSCRIPTION_FAILURE: "USERS_SETSUBSCRIPTION_FAILURE",

  GETUSERSUBSCRIPTION_REQUEST: "USERS_GETSUBSCRIPTION_REQUEST",
  GETUSERSUBSCRIPTION_SUCCESS: "USERS_GETSUBSCRIPTION_SUCCESS",
  GETUSERSUBSCRIPTION_FAILURE: "USERS_GETSUBSCRIPTION_FAILURE",

  CANCELUSERSUBSCRIPTION_REQUEST: "USERS_CANCELSUBSCRIPTION_REQUEST",
  CANCELUSERSUBSCRIPTION_SUCCESS: "USERS_CANCELSUBSCRIPTION_SUCCESS",
  CANCELUSERSUBSCRIPTION_FAILURE: "USERS_CANCELSUBSCRIPTION_FAILURE",

  GETFREEASSESSMENT_REQUEST: "USERS_GETFREEASSESSMENT_REQUEST",
  GETFREEASSESSMENT_SUCCESS: "USERS_GETFREEASSESSMENT_SUCCESS",
  GETFREEASSESSMENT_FAILURE: "USERS_GETFREEASSESSMENT_FAILURE",
};
